
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class TabCustom extends Vue {
  @Prop() readonly tabs: Array<any> | undefined;
  @Prop() readonly defaultActive: string | undefined;

  tabChanged(key: string) {
    if(key !== this.defaultActive)
    {
      this.$emit('tabChanged', key);
    }
  }
}
